import axios from "axios";
import Cookies from "universal-cookie";

const apiURL = process.env.NODE_ENV === "development" ? "http://localhost:3001" : process.env.REACT_APP_BACKEND_API_URL;

const cookies = new Cookies();
const token = cookies.get("TOKEN");
axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

export const getMetalsService = async () => {
  const token = cookies.get("TOKEN");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/metals`);
  return res;
};

export const getSalesMaterialsService = async (office: string, pageNumber: string, filters: any) => {
  const token = cookies.get("TOKEN");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  console.log(office, filters);
  const res = await axios.get(
    `${apiURL}/metalstrading/api/sales/materials?office=${office}&page=${pageNumber}&metals=${filters.metals}&startDate=${filters.startDate}&endDate=${filters.endDate}`
  );
  return res;
};

export const getBuyersService = async () => {
  const token = cookies.get("TOKEN");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/buyers`);
  return res;
};

export const getSaleService = async (office: string, saleID: string) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/sales/${saleID}?office=${office}`);
  return res;
};
